module.exports = __webpack_public_path__ + "img/ga4_icone.c4118bba.png";